<template>
  <v-container>
    <v-card
      :loading="false"
    >
      <v-overlay
        :absolute="true"
        :value="isComponentLoading"
      >
        <v-progress-circular indeterminate size="24"></v-progress-circular>
      </v-overlay>
      <v-row class="pa-3">
        <v-col cols="12" md="6">
          <v-text-field
            v-model="searchText"
            :hint="lang($store, 'sap/listings.global.filter.hints.search_name_contact')"
            persistent-hint
            single-line
            :loading="false"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="searchTextCleaner"
            :hint="lang($store, 'sap/listings.global.filter.hints.search_name_cleaner')"
            persistent-hint
            single-line
            :loading="false"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            v-model="searchParams.region"
            :hint="lang($store, 'sap/listings.global.filter.hints.region')"
            :items="regionsItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-menu
            v-model="menuFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="fromDateFormatted"
                @input="changeDate('from', $event)"
                :label="lang($store, 'sap/listings.global.filter.hints.date_from')"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="searchParams.from" no-title
                           :first-day-of-week="1"
                           :locale="getCurrentLocale()"
                           @input="menuFrom = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="4">
          <v-menu
            v-model="menuTo"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="toDateFormatted"
                @input="changeDate('to', $event)"
                :label="lang($store, 'sap/listings.global.filter.hints.date_to')"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="searchParams.to" no-title
                           :first-day-of-week="1"
                           :locale="getCurrentLocale()"
                           @input="menuTo = false"></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" md="4">
          <v-select
            multiple
            v-model="searchParams.statuses"
            :items="damageStatusesStatusItems"
            prepend-icon="mdi-cart-arrow-right"
            single-line
            :hint="lang($store, 'sap/listings.global.filter.hints.order_status')"
            persistent-hint
          ></v-select>
        </v-col>

        <v-col cols="12" md="4">
          <v-select
            multiple
            v-model="searchParams.order_types"
            :items="orderTypesItems"
            prepend-icon="mdi-cart-arrow-right"
            single-line
            :label="lang($store, 'sap/listings.global.filter.hints.type')"
            :hint="lang($store, 'sap/listings.global.filter.hints.type')"
            persistent-hint
          ></v-select>
        </v-col>

      </v-row>
      <download-file-button
        v-if="account.role === MANAGER_TOP"
        :use-download-report-users="true"
        style="position: absolute; top: 5px; right: 5px"
        @click="$emit('download-excel')"
      />
    </v-card>
  </v-container>
</template>

<script>
import moment from 'moment';
/* constants */
import { OPEN } from '@/constants/damage_statuses';

/* mixins */
import regionsFilter from '@/mixins/filters/regionsFilter';
import payedFilter from '@/mixins/filters/payedFilter';
import searchTextFilter from '@/mixins/filters/searchTextFilter';
import searchCleanerFilter from '@/mixins/filters/searchCleanerFilter';
import damagesStatusFilter from '@/mixins/filters/damagesStatusFilter';
import orderTypesFilter from '@/mixins/filters/orderTypesFilter';


/* components */
import DownloadFileButton from '@/components/minialerts/DownloadFileButton.vue';
import { MANAGER_TOP } from '@/constants/roles';
import isComponentLoading from '../../mixins/isComponentLoading';

export default {
  name: 'FilterDamages',
  mixins: [
    isComponentLoading,
    regionsFilter,
    payedFilter,
    searchTextFilter,
    searchCleanerFilter,
    damagesStatusFilter,
    orderTypesFilter,
  ],
  components: {
    DownloadFileButton,
  },
  props: {
    defaultSearchParams: {
      type: Object,
      default: () => ({
        search_contact: '',
        search_cleaner: '',
      }),
    },
  },
  data() {
    return {
      MANAGER_TOP,
      useNullableDamageStatus: false,
      searchParams: {},
      menuFrom: false,
      menuTo: false,
    };
  },
  mounted() {
    this.searchParams = {
      search_contact: this.defaultSearchParams.search_contact,
      search_cleaner: this.defaultSearchParams.search_cleaner,
      /* from: moment()
          .startOf('month')
          .format(DATE_ISO), */
      from: null,
      to: null,
      statuses: [
        OPEN,
      ],
      order_types: null,
      is_payed: null,
      region: null,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
    fromDateFormatted() {
      return this.formatDate(this.searchParams.from);
    },
    toDateFormatted() {
      return this.formatDate(this.searchParams.to);
    },
  },
  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('filtering', newVal);
      },
      deep: true,
    },
  },
  methods: {
    getCurrentLocale() {
      return window.localStorage.language;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    changeDate(type, date) {
      if (date === null) {
        this.searchParams[type] = null;
      }
    },
  },
};
</script>

<style scoped>

</style>
